export interface SeasonalPromo {
  id: string;
  name: string;
  startMonth: number; // 0-indexed (0 = January)
  startDay: number;
  endMonth: number;
  endDay: number;
  bannerText: string;
  ctaText: string;
  pageHeadline: string;
  pageSubheadline: string;
  discountCode: string;
  discountAmount: string;
  features: string[];
  theme: "spring" | "summer" | "fall" | "holiday" | "newyear";
}

export const seasonalPromos: SeasonalPromo[] = [
  {
    id: "spring-cleaning",
    name: "Spring Cleaning Event",
    startMonth: 2, // March
    startDay: 1,
    endMonth: 4, // May
    endDay: 31,
    bannerText: "🌸 Spring Cleaning Special: Get $50 off a Deep Clean!",
    ctaText: "Claim Offer",
    pageHeadline: "Refresh Your Home for Spring",
    pageSubheadline: "Shake off the winter dust with our comprehensive spring deep cleaning package. Book now and save $50.",
    discountCode: "SPRING50",
    discountAmount: "$50 Off",
    features: [
      "Deep dusting of all surfaces and ceiling fans",
      "Baseboard and window sill hand-wiping",
      "Inside window glass cleaning",
      "Appliance exterior polishing",
      "Deep floor sanitization"
    ],
    theme: "spring"
  },
  {
    id: "summer-refresh",
    name: "Summer Refresh",
    startMonth: 5, // June
    startDay: 1,
    endMonth: 7, // August
    endDay: 31,
    bannerText: "☀️ Summer Refresh: Free Fridge Cleaning with any Deep Clean!",
    ctaText: "Get Details",
    pageHeadline: "Keep Your Home Cool & Clean This Summer",
    pageSubheadline: "Enjoy the sunshine while we handle the scrubbing. Get a free inside-fridge cleaning when you book a Deep Clean.",
    discountCode: "SUMMERCOOL",
    discountAmount: "Free Fridge Clean ($40 Value)",
    features: [
      "Inside refrigerator detail cleaning",
      "Focus on high-traffic entryways",
      "Kitchen sanitization",
      "Bathroom deep clean",
      "Pet hair removal focus"
    ],
    theme: "summer"
  },
  {
    id: "fall-prep",
    name: "Fall Prep & Purge",
    startMonth: 8, // September
    startDay: 1,
    endMonth: 9, // October
    endDay: 31,
    bannerText: "🍂 Fall Special: 15% off your first recurring clean!",
    ctaText: "Claim Discount",
    pageHeadline: "Get Your Home Ready for Cozy Season",
    pageSubheadline: "Prepare for more time indoors. Start a recurring cleaning plan this fall and get 15% off your first visit.",
    discountCode: "FALL15",
    discountAmount: "15% Off First Clean",
    features: [
      "Setup for weekly or bi-weekly service",
      "Initial detail-heavy reset clean",
      "Dusting of vents and hard-to-reach areas",
      "Kitchen & bathroom sanitization",
      "Consistent, reliable scheduling"
    ],
    theme: "fall"
  },
  {
    id: "holiday-ready",
    name: "Holiday Ready Clean",
    startMonth: 10, // November
    startDay: 1,
    endMonth: 11, // December
    endDay: 31,
    bannerText: "🎁 Holiday Prep: Ensure your home is guest-ready! Save $40.",
    ctaText: "Book Now",
    pageHeadline: "Stress-Free Holiday Hosting",
    pageSubheadline: "Don't stress over the mess. Let us prepare your home for family and guests with our Holiday Ready Deep Clean.",
    discountCode: "HOLIDAY40",
    discountAmount: "$40 Off",
    features: [
      "Guest bathroom deep sanitization",
      "Kitchen appliance exterior detailing",
      "Living area deep dusting",
      "Entryway and floor shining",
      "Oven cleaning available as add-on"
    ],
    theme: "holiday"
  },
  {
    id: "new-year-reset",
    name: "New Year Reset",
    startMonth: 0, // January
    startDay: 1,
    endMonth: 1, // February
    endDay: 28,
    bannerText: "✨ New Year, Clean Home: $60 off Move-In/Out or Deep Cleans!",
    ctaText: "Start Fresh",
    pageHeadline: "Start the Year with a Spotless Slate",
    pageSubheadline: "Reset your space for the new year. Get our biggest discount on Deep Cleans and Move-In/Out packages.",
    discountCode: "FRESH60",
    discountAmount: "$60 Off",
    features: [
      "Complete home reset",
      "Inside cabinets (Move-Out package)",
      "Baseboards and doors wiped",
      "Intensive bathroom scrubbing",
      "Kitchen degreasing"
    ],
    theme: "newyear"
  }
];

export function getActivePromo(): SeasonalPromo | null {
  const now = new Date();
  const month = now.getMonth();
  const day = now.getDate();
  const currentWeight = month * 100 + day;

  return seasonalPromos.find(promo => {
    const startWeight = promo.startMonth * 100 + promo.startDay;
    const endWeight = promo.endMonth * 100 + promo.endDay;

    if (startWeight <= endWeight) {
      return currentWeight >= startWeight && currentWeight <= endWeight;
    } else {
      // Handles wrapping around the end of the year (e.g., Dec to Jan)
      return currentWeight >= startWeight || currentWeight <= endWeight;
    }
  }) || null;
}
